import React, { useMemo } from "react";
import ImageGallery, { ImageGalleryItem } from "../ImageGallery";

const srcBase = "/images/common/payment-methods";

interface Props {
  className?: string;
}

const PaymentMethodsGallery = ({ className }: Props) => {
  const methods: ImageGalleryItem[] = useMemo(() => {
    return [
      "amex",
      "diners-club",
      "discover",
      "jcb",
      "mastercard",
      "visa",
      "paypal",
      "apple",
      "google",
    ].map((cert) => ({
      name: cert,
      src: `${srcBase}/${cert}.png`,
    }));
  }, []);

  return <ImageGallery maxHeight={30} images={methods} className={className} />;
};

export default PaymentMethodsGallery;
